module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOAgMAAABiJsVCAAAACVBMVEXZ2dn////Y2NiuGC7LAAAAAXRSTlO1++2fZQAAABZJREFUCNdj0Fq1qoFhamhoApkE2AAAN3sXcRJWyl0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/checkbox.png
// module id = 5ZEc
// module chunks = 2